import VideoCropper from '@/views/videoCropper.vue';
import CropperVideoPanel from '@/components/rightPanel/cropperVideoPanel.vue';

export default {
  name: 'Cropper',
  path: '/cropper',
  components: {
    default: VideoCropper,
    panel: CropperVideoPanel
  }
};
